<nav
  class="breadcrumb-nav w-full"
  [class.product-list-breadcrumb]="isProductList"
  [class.product-detail-breadcrumb]="!isProductList && !!productName"
  aria-label="breadcrumb"
>
  <ol class="breadcrumb">
    <!-- Dynamic breadcrumbs for product list and product detail -->
    <ng-container
      *ngIf="(isProductList || partType || categoryName || productName) && dynamicBreadcrumbs.length > 0"
    >
      <li
        class="breadcrumb-item"
        *ngFor="
          let breadcrumb of dynamicBreadcrumbs;
          let last = last;
          let i = index
        "
      >
        <ng-container *ngIf="!last">
          <a
            (click)="onBreadcrumbClick(breadcrumb, i)"
            [ngStyle]="{ cursor: breadcrumb.url ? 'pointer' : 'default' }"
            [class]="
              breadcrumb.active
                ? 'text-gray-500 whitespace-nowrap'
                : 'text-blue-600 hover:text-blue-800 whitespace-nowrap'
            "
          >
            {{ breadcrumb.label | uppercase }}
          </a>
        </ng-container>
        <ng-container *ngIf="last">
          <span class="text-gray-500 cursor-default line-clamp-1">{{
            breadcrumb.label | uppercase
          }}</span>
        </ng-container>
      </li>
    </ng-container>

    <!-- Legacy breadcrumbs for other pages -->
    <ng-container
      *ngIf="
        !isProductList && !productName && breadcrumbs && breadcrumbs.length > 0
      "
    >
      <li class="breadcrumb-item whitespace-nowrap cursor-pointer">
        <a [routerLink]="['/home']">HOME </a>
      </li>
      <ng-container
        *ngFor="let breadcrumb of breadcrumbs; last as last; let i = index"
      >
        <li
          *ngIf="!last"
          class="breadcrumb-item whitespace-nowrap cursor-pointer"
        >
          <a
            (click)="GotoRoute(breadcrumb, i)"
            [ngStyle]="{ cursor: getCursor(breadcrumb.label) }"
            >{{ breadcrumb.label | uppercase }}</a
          >
        </li>
        <li *ngIf="last" class="breadcrumb-item cursor-pointer line-clamp-1">
          <a style="cursor: default; color: #9197b0">
            {{ breadcrumb.label | uppercase }}</a
          >
        </li>
      </ng-container>
    </ng-container>
  </ol>
</nav>
